import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import ManagerHookUpSUKL from './ManagerHookUpSUKL';

interface Props extends BaseModalProps {
	onSave: () => void;
}

const ManagerHookUpSUKLModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='component.hookUp.sukl.connection'>
			<ManagerHookUpSUKL onSave={props.onSave} />
		</BaseModal>
	);
};

export default ManagerHookUpSUKLModal;
